import { route } from 'react-router-typesafe-routes';

export const USER_NOT_FOUND_ROUTE = route({ path: 'user-not-found/:email' });
